import { useForm } from "react-hook-form";
import {
  INewPasswordFormModel,
  newPasswordDefaultValues,
  newPasswordFormSchema,
} from "../models/newPasswordFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useFormValidationMessages } from "../../../common/infrastructure/hooks/useFormHelper";

export const useNewPasswordForm = (
  email: string,
  token: string,
  studioId: string
) => {
  const form = useForm<INewPasswordFormModel>({
    defaultValues: newPasswordDefaultValues,
    resolver: yupResolver(newPasswordFormSchema),
  });

  useEffect(() => {
    form.setValue("token", token);
    form.setValue("email", email);
    form.setValue("studioId", studioId);
  }, [email, token]);

  useFormValidationMessages<INewPasswordFormModel>(form);

  return form;
};
